import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { isFunction } from 'lodash';
import { useLocation } from 'react-router';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import styles from './actionsCell.module.scss';

// MAIN COMPONENT
const ActionsCell = ({
  column: { actions: columnActions } = {},
  row: { original } = {},
  actions = columnActions, //
  record = original
}) => {
  // REACT ROUTER
  const location = useLocation();

  // RENDER
  return actions?.length
    ? actions.map(({ className, to, onClick, ...action }, i) => (
        <Button.Link
          key={i}
          className={clsx(styles.button, action.label && styles.labeled, className)}
          to={
            to
              ? {
                  pathname: isFunction(to) ? to(record, location) : to,
                  state: {
                    prevPath: location.pathname,
                    queryParams: location.state?.queryParams
                  }
                }
              : undefined
          }
          onClick={isFunction(onClick) ? e => onClick(e, record) : undefined}
          {...action}
        />
      ))
    : null;
};

// EXPORT
export default ActionsCell;
